// extracted by mini-css-extract-plugin
export default {"container":"card-container_container__3jf9t"};